import postal from 'postal';
import { useContext, useEffect } from 'react';

import { createGoal } from './actions/goals/Goal';
import { kind } from './actions/goals/Restart';
import { dataManagerContext } from './dataManagerContext';

export function useRestart() {
  const { dispatch } = useContext(dataManagerContext);
  useEffect(() => {
    // Restart Sync - Only used in the case of bad doc being removed form the sync process
    // This fixes the 'Document not found in collection' error
    const postalSub = postal.subscribe({
      channel: 'db',
      topic: 'db.restart',
      callback: () => {
        dispatch(createGoal(kind));
      },
    });

    return () => {
      postalSub.unsubscribe();
    };
  }, [dispatch]);
}
